import { defineStore } from "pinia";
import { ref } from "vue";

export const useLessonSessionStore = defineStore("lessonSession", () => {
  const endedByLesson = ref(new Map<string, boolean>());

  function isEnded(lessonUUId: string | undefined | null): boolean {
    if (!lessonUUId) return false;
    return endedByLesson.value.get(lessonUUId) === true;
  }

  function setEnded(lessonUUId: string, ended: boolean) {
    const next = new Map(endedByLesson.value);
    next.set(lessonUUId, ended);
    endedByLesson.value = next;
  }

  return { isEnded, setEnded };
});
